// store/index.js
 
import Vue from "vue";
import Vuex from "vuex";
 
Vue.use(Vuex);
 
export default new Vuex.Store({
    state: {
        user: {
            username: '',
            email: 'Log In',
            userId: '',
            isAdmin: false,
            //firstName: '',
            //currentRestaurant: '',
        },
        globals:{            
            sessionValidated: false,   
            passwordPattern: /((?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,20})/,         
            passwordMessage: "Must have at least 8 characters, 1 capital, and 1 number",
        },
        appSettings: {
            webServiceUrl: 'service/ContactTracingService.svc/',
            locationURLprefix: 'https://dinesafeapp.co/dinesafevt/#/contact-info/',
            loadOfflineData: false,
        },
        data: {
            accountContactHistory: null,
            locationData: null,
            currentAccountId: '',
            currentAccountName: '',
        }
    },
    getters: {
        //userId: this.user.userId,
        //userIsAdmin: this.user.isAdmin,        
    },
    mutations: {
        setSessionValidated (state, payload) {
            state.globals.sessionValidated = payload;
        },
        setEmail (state, payload) {
            state.user.email = payload;
        },
        setUserId (state, payload) {
            state.user.userId = payload;
        },
        setIsAdmin (state, payload) {
            state.user.isAdmin = payload;
        },
        setCurrentAccountName (state, payload) {
            state.data.currentAccountName = payload;
        },
        setAccountContactHistory (state, payload) {
            state.data.accountContactHistory = payload;
        },
        setLocationData (state, payload) {
            state.data.locationData = payload;
        },
        setCurrentAccountId (state, payload) {
            state.data.currentAccountId = payload;
        },
     },
    actions: {}
});